import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 0 }

import MessageUserButton from 'src/components/adverts/MessageUserButton.vue';
import {useQuasar} from 'quasar';
import {Business} from 'src/models/business.model';
import BusinessApi from 'src/api/business'
import {PropType, ref, toRef} from 'vue';
import {useMainStore} from 'stores/main';
import {useRoute, useRouter} from 'vue-router';
import {openExternalLink} from 'src/etc/utils';
import {share} from 'src/apps/core/utils';
import {useTracking} from 'src/etc/tracking';


export default /*@__PURE__*/_defineComponent({
  __name: 'BusinessProfileActionBtns',
  props: {
  business: {
    type: Object as PropType<Business>
  }
},
  setup(__props) {


const $q = useQuasar()

const props = __props

const mainStore = useMainStore()
const businessRef = toRef(props, 'business')
const isSubscribed = ref(businessRef.value?.is_subscribed)
const route = useRoute()
const router = useRouter()
const playRingAnimation = ref(false)

const shareBusiness = async function () {
  const text = `${props.business?.name} auf CamperTrader.de`

  await share($q, {
    title: text,
    text: text,
    url: `${process.env.BASE_URL}${router.resolve({
      name: 'business-profile',
      params: {slug: props.business?.slug}
    }).fullPath}`,
    dialogTitle: 'Profil Teilen',
    mtmSource: 'BusinessProfile'
  })
}

const subscribe = () => {
  playRingAnimation.value = false
  if (!props.business?.slug) return
  if (!mainStore.isLoggedIn) {
    router.push({name: 'login', query: {n: route.fullPath, required: 'yes'}})
    return
  }
  BusinessApi.toggleSubscriptionBusiness(props.business.slug).then(resp => {
    isSubscribed.value = resp.data.is_subscribed
    if (isSubscribed.value) {
      playRingAnimation.value = true
    }
  })
}

function clickPhone() {
  const tracker = useTracking()
  const url = `tel:${props.business?.phone}`
  tracker.trackInteractionPhone('business')
  window.open(url, '_blank')
}

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex items-center no-wrap q-gutter-x-sm", {'justify-end': _unref($q).screen.gt.xs}])
  }, [
    _createElementVNode("div", null, [
      _createVNode(_component_q_btn, {
        round: !_unref($q).screen.gt.xs,
        color: "grey-3",
        rounded: "",
        "text-color": "grey-9",
        unelevated: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (shareBusiness()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_icon, {
            name: "fas fa-share-alt",
            size: "xs"
          }),
          (_unref($q).screen.gt.xs)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("  Teilen")
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["round"])
    ]),
    (__props.business?.phone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_q_btn, {
            class: "c-btn--special",
            round: "",
            unelevated: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (clickPhone()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "fas fa-phone",
                size: "xs"
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (__props.business?.uuid && !__props.business.is_temporary)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(MessageUserButton, {
            class: "full-width",
            round: _unref($q).screen.width < 360,
            rounded: !(_unref($q).screen.width < 360),
            "has-label": _unref($q).screen.width > 360,
            label: _unref($q).screen.lt.sm ? 'Nachricht' : 'Nachricht senden',
            "has-icon": true,
            disable: _unref(mainStore).accountDetail?.businesses?.flatMap(obj => obj.uuid).includes(__props.business?.uuid),
            "show-modal": false,
            "user-uuid": __props.business.uuid
          }, null, 8, ["round", "rounded", "has-label", "label", "disable", "user-uuid"])
        ]))
      : _createCommentVNode("", true),
    (!__props.business?.is_temporary)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_q_btn, {
            class: _normalizeClass(["full-width", {'ring-grow-animation': playRingAnimation.value}]),
            color: !isSubscribed.value ? 'primary' : 'grey-3',
            "text-color": !isSubscribed.value ? 'white' : 'grey-9',
            rounded: "",
            unelevated: "",
            "no-caps": "",
            onClick: subscribe
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "fas fa-bell ring",
                size: "xs"
              }),
              _createTextVNode("  " + _toDisplayString(!isSubscribed.value ? 'Abonnieren' : 'Abonniert'), 1)
            ]),
            _: 1
          }, 8, ["class", "color", "text-color"])
        ]))
      : _createCommentVNode("", true),
    (__props.business?.is_temporary)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          (__props.business?.website)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_q_btn, {
                  target: "_blank",
                  class: "full-width",
                  color: "dark",
                  rounded: "",
                  unelevated: "",
                  "no-caps": "",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(openExternalLink)(__props.business.website)))
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode(" Zur Webseite ")
                  ])),
                  _: 1,
                  __: [3]
                })
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 2))
}
}

})